<template lang="pug">
div
  .goal(:style="{'background-color': goal.color}" :class="{leaf: goal.parent && goal.parent.isLeaf}") {{goal.title}}
  ul
    li(v-if="goal.description && filteredChildren().length === 0") {{goal.description}}
    li(v-for="g in filteredChildren()")
      GoalTree(:row="row" :goal="g")

</template>

<script>
  export default {
    props: ['row', 'goal'],
    name: 'GoalTree',
    methods: {
      hasTag(g) {
        if (!this.row.tags) return false

        //does it have any of the tags of my row under it?
        let allKeys = (r) => {
          let ks = [r.key, r.code]
          _.each(r.children, (c) => {
            ks = ks.concat(allKeys(c))
          })
          return _.flatten(ks)
        }
        let keys = allKeys(g)
        return _.intersection(keys, this.row.tags).length > 0
      },
      filteredChildren() {
        if (this.goal.hasChildren) {
          return _.filter(this.goal.children, this.hasTag)
        } else {
          return []
        }
      }
    }
        
  }
</script>

<style scoped>
ul {
  margin: 4px 0 0 16px;
}
.goal {
  display: inline-block;
  font-size: 12px;
  padding: 4px;
  border: 1px solid #666;
  border-radius: 4px;
}
.goal.leaf {
  border: none;
  background-color: transparent !important;
}
</style>